import _ from 'underscore';

import CoreModel from 'core/models/core';


// UserProgress model
export default CoreModel.extend({
  urlRoot: USERPROGRESS_API_URL,
  track_data: function () {
    var data_attrs = this.flatten_rec(this.attributes, null, this);
    var track_data = {
      'Percent Complete': data_attrs.percentage_complete,
      'Quiz Name': data_attrs.screener_set_item__screener__name,
      'Score': data_attrs.score
    };
    // Add to track data all of the ``options_`` attributes
    for (var key in data_attrs) {
      if (key.indexOf('options_') !== -1) {
        if (key === 'options_birth-year_value') {
          track_data['Year Born'] = data_attrs[key];
        } else if (key === 'options_gender_value') {
          track_data.Gender = data_attrs[key];
        } else {
          // Replace underscore and dash with spaces (if any) and convert first letter to uppercase
          var option_name = key.replace(/[_-]/g, ' ').replace(/\b./g, function (m) { return m.toUpperCase(); });
          track_data[option_name] = data_attrs[key];
        }
      }
    }
    return track_data;
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/models/user_progress.js
// module id = 165
// module chunks = 0